import { ObjectSerializer } from "../../DiscoveryEngine.TS/Serialization/ObjectSerializer";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { HashSet } from "../../DiscoveryEngine.TS/Utils/HashSet";


export class AgentUpdateDescriptor implements ObjectSerializer {

	public CreatedSchedDiscGuids: HashSet<string>;
	public DeletedSchedDiscGuids: HashSet<string>;
	public ModifiedSchedDiscGuids: HashSet<string>;

	constructor() {
		this.CreatedSchedDiscGuids = new HashSet<string>();
		this.DeletedSchedDiscGuids = new HashSet<string>();
		this.ModifiedSchedDiscGuids = new HashSet<string>();
	}

	public get HasCreatedSchedDiscGuids(): boolean {
		return (this.CreatedSchedDiscGuids.Count > 0);
	}

	public get HasDeletedSchedDiscGuids(): boolean {
		return (this.DeletedSchedDiscGuids.Count > 0);
	}

	public get HasModifiedSchedDiscGuids(): boolean {
		return (this.ModifiedSchedDiscGuids.Count > 0);
	}

	public Write(obj: any, context: any): void {

		obj.agent_update_descriptor = {};
		obj = obj.agent_update_descriptor;

		if (this.HasCreatedSchedDiscGuids) {
			obj.created_sched_disc_guids = [];
			ObjSerUtils.WriteStringValueCollection(obj.created_sched_disc_guids, this.CreatedSchedDiscGuids, context);
		}

		if (this.HasDeletedSchedDiscGuids) {
			obj.deleted_sched_disc_guids = [];
			ObjSerUtils.WriteStringValueCollection(obj.deleted_sched_disc_guids, this.DeletedSchedDiscGuids, context);
		}

		if (this.HasModifiedSchedDiscGuids) {
			obj.modified_sched_disc_guids = [];
			ObjSerUtils.WriteStringValueCollection(obj.modified_sched_disc_guids, this.ModifiedSchedDiscGuids, context);
		}
	}

	public Read(obj: any, context: any): void
	{
		if (!obj.agent_update_descriptor)
			throw new Error();
		obj = obj.agent_update_descriptor;

		if (obj.created_sched_disc_guids !== undefined) {
			ObjSerUtils.ReadStringValueCollection(obj.created_sched_disc_guids, this.CreatedSchedDiscGuids, context);
		}

		if (obj.deleted_sched_disc_guids !== undefined) {
			ObjSerUtils.ReadStringValueCollection(obj.deleted_sched_disc_guids, this.DeletedSchedDiscGuids, context);
		}

		if (obj.modified_sched_disc_guids !== undefined) {
			ObjSerUtils.ReadStringValueCollection(obj.modified_sched_disc_guids, this.ModifiedSchedDiscGuids, context);
		}
	}
}